// components/RepliesPage/tabs/EmptyTabState.tsx
import { LoaderCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ReactNode } from "react";

interface EmptyTabStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  onRefresh: () => Promise<void>;
  isRefreshing: boolean;
  actionText: string;
  actionIcon: ReactNode;
}

const EmptyTabState: React.FC<EmptyTabStateProps> = ({
  icon,
  title,
  description,
  onRefresh,
  isRefreshing,
  actionText,
  actionIcon,
}) => {
  return (
    <div className="text-center p-12 border rounded-lg bg-muted/20">
      <div className="flex justify-center">
        <div className="rounded-full bg-muted/30 p-4 mb-4 w-16 h-16 flex items-center justify-center">
          <div className="text-muted-foreground">{icon}</div>
        </div>
      </div>
      <h3 className="text-lg font-medium mb-2">{title}</h3>
      <p className="text-sm text-muted-foreground mb-4 max-w-md mx-auto">
        {description}
      </p>
      <Button
        variant="outline"
        size="sm"
        onClick={onRefresh}
        className="mt-2"
        disabled={isRefreshing}
      >
        {isRefreshing ? (
          <LoaderCircle className="h-4 w-4 animate-spin mr-2" />
        ) : (
          actionIcon
        )}
        {actionText}
      </Button>
    </div>
  );
};

export default EmptyTabState;
